(function () {
  if (window.__pcLandingUtmInit) {
    return;
  }
  window.__pcLandingUtmInit = true;

  const STORAGE_KEY = 'pc_landing_query_params';

  function capture() {
    try {
      const current   = new URLSearchParams(window.location.search);
      const preserved = {};
      current.forEach((value, key) => {
        preserved[key] = value;
      });
      if (Object.keys(preserved).length) {
        const existing = read();
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({}, existing, preserved)));
      }
    } catch (e) {
      console.error('[landing-utm] Failed to capture query params', e);
    }
  }

  function read() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function appendToUrl(url) {
    const params = read();
    if (!Object.keys(params).length) {
      return url;
    }
    try {
      const parsed = new URL(url, window.location.origin);
      Object.keys(params).forEach((key) => {
        if (!parsed.searchParams.has(key)) {
          parsed.searchParams.set(key, params[key]);
        }
      });
      const isAbsolute = /^https?:\/\//i.test(url);
      return isAbsolute ? parsed.toString() : parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      return url;
    }
  }

  function isInternalHref(a) {
    const href = a.getAttribute('href') || '';
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
      return false;
    }
    try {
      const parsed = new URL(href, window.location.origin);
      if (parsed.origin !== window.location.origin) {
        return false;
      }
      // Skip Shopify-hosted flows that shouldn't inherit marketing params.
      if (parsed.pathname.startsWith('/checkout') || parsed.pathname.startsWith('/cart')) {
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function rewriteLinks(root) {
    if (!Object.keys(read()).length) {
      return;
    }
    (root || document).querySelectorAll('a[href]').forEach((a) => {
      if (a.dataset.pcUtmApplied === '1' || !isInternalHref(a)) {
        return;
      }
      a.href                  = appendToUrl(a.getAttribute('href'));
      a.dataset.pcUtmApplied  = '1';
    });
  }

  function init() {
    capture();
    rewriteLinks(document);
  }

  // Expose helpers for other landing scripts (e.g. checkout redirect).
  window.pcLandingUtm = {
    read         : read,
    appendToUrl  : appendToUrl,
    rewriteLinks : rewriteLinks
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
